import { NativeProps, withNativeProps } from '../utils';
import './style.less';

export const Page404 = (props: NativeProps) => {
  return withNativeProps(props, <div className="v-404">404</div>);
};
